import React from "react";

const LINKS = [
  "Home", "About", "Privacy", "FAQ", "Webmasters", "Sitemap", "Contact Us",
];

export default function TopLinksBar() {
  return (
    <div
      data-testid="top-links"
      className="flex items-center gap-2 px-3 py-1.5 text-[12px] text-white"
      style={{
        background: "linear-gradient(to bottom, #003c9e, #0053e1)",
        borderBottom: "1px solid #002a6e",
      }}
    >
      <span className="text-[#FFEB3B] font-bold">lemonwire.fm</span>
      <span className="opacity-60">|</span>
      {LINKS.map((l, i) => (
        <React.Fragment key={l}>
          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            className="hover:underline hover:text-[#FFEB3B]"
            style={{ color: "white" }}
          >
            {l}
          </a>
          {i < LINKS.length - 1 && <span className="opacity-40">·</span>}
        </React.Fragment>
      ))}
      <span className="ml-auto text-[10px] opacity-70 font-mono">
        Last updated: 02/18/2026 · build 8873
      </span>
    </div>
  );
}
